import React, { useEffect, useState } from 'react'
import Dropdown from '../../../../components/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { setIndustry2Options, setIndustry3Options, setJobType2Options, setJobType3Options } from 'reducers/companyTalent';

const CareerSection = ({ formAdvanceData, setFormAdvanceData }) => {
  const dispatch = useDispatch();
  const { expectedConditionOptions, preferredCityOptions, workingStyleOptions, changeJobOptions, jobType1Options, jobType2Options, jobType3Options,industry1Options, industry2Options, industry3Options } = useSelector((state: any) => state.companyTalent);
  const { talentOptionsRelatedRegister } = useSelector((state: any) => state.talentRegister);

  useEffect(() => {
    // Check related options
    if(formAdvanceData?.profession_1_id?.id && !formAdvanceData?.profession_2_id?.id) {
      dispatch(setJobType2Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == formAdvanceData?.profession_1_id?.code && item.level == 2)));
    }
    if(formAdvanceData?.profession_2_id?.id && !formAdvanceData?.profession_3_id?.id) {
      dispatch(setJobType3Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == formAdvanceData?.profession_2_id?.code && item.level == 3)));
    }
    if(formAdvanceData?.industry_1_id?.id && !formAdvanceData?.industry_2_id?.id) {
      dispatch(setIndustry2Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == formAdvanceData?.industry_1_id?.code && item.level == 2)));
    }
    if(formAdvanceData?.industry_2_id?.id && !formAdvanceData?.industry_3_id?.id) {
      dispatch(setIndustry3Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == formAdvanceData?.industry_2_id?.code && item.level == 3)));
    }
  }, [formAdvanceData]);

  const handleChangeJobTypeLevel1 = (value) => {
      setFormAdvanceData((prev: any) => ({
          ...prev,
          profession_1_id: value,
          profession_2_id: null,
          profession_3_id: null,
      }));

      // Reload options level 2
      if (value && value.code) {
          dispatch(setJobType2Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == value.code && item.level == 2)));
      } else {
          dispatch(setJobType2Options([]));
      }

      // Reload options level 3
      dispatch(setJobType3Options([]));
  }

  const handleChangeJobTypeLevel2 = (value) => {
      setFormAdvanceData((prev: any) => ({
          ...prev,
          profession_2_id: value,
          profession_3_id: null,
      }));

      // Reload options level 3
      if (value && value.code) {
          dispatch(setJobType3Options(talentOptionsRelatedRegister?.jobTypeOptions.filter(item => item.parent_id == value.code && item.level == 3)));
      } else {
          dispatch(setJobType3Options([]));
      }
  }

  const handleChangeIndustryLevel1 = (value) => {
      setFormAdvanceData((prev: any) => ({
          ...prev,
          industry_1_id: value,
          industry_2_id: null,
          industry_3_id: null,
      }));

      // Reload options level 2
      if (value && value.code) {
          dispatch(setIndustry2Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == value.code && item.level == 2)));
      } else {
          dispatch(setIndustry2Options([]));
      }

      // Reload options level 3
      dispatch(setIndustry3Options([]));
  }

  const handleChangeIndustryLevel2 = (value) => {
      setFormAdvanceData((prev: any) => ({
          ...prev,
          industry_2_id: value,
          industry_3_id: null,
      }));

      // Reload options level 3
      if (value && value.code) {
          dispatch(setIndustry3Options(talentOptionsRelatedRegister?.industryOptions.filter(item => item.parent_id == value.code && item.level == 3)));
      } else {
          dispatch(setIndustry3Options([]));
      }
  }

  return (
    <>
      <p className='text-sm font-bold alu-text-base-2 mb-6'>キャリア</p>
      {/* created_at */}
      <div className='flex flex-col gap-8'>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した職種１</label>
            {/* change_job */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={jobType1Options}
              placeholder=""
              value={formAdvanceData.profession_1_id}
              onChange={(value: any) => handleChangeJobTypeLevel1(value)}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した職種２</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              disabled={!formAdvanceData.profession_1_id}
              options={jobType2Options}
              placeholder=""
              value={formAdvanceData.profession_2_id}
              onChange={(value: any) => handleChangeJobTypeLevel2(value)}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した職種３</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              disabled={!formAdvanceData.profession_2_id}
              options={jobType3Options}
              placeholder=""
              value={formAdvanceData.profession_3_id}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, profession_3_id: value }))
              }}
            />
          </div>
        </div>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した業種１</label>
            {/* change_job */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={industry1Options}
              placeholder=""
              value={formAdvanceData.industry_1_id}
              onChange={(value: any) => handleChangeIndustryLevel1(value)}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した業種２</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              disabled={!formAdvanceData.industry_1_id}
              options={industry2Options}
              placeholder=""
              value={formAdvanceData.industry_2_id}
              onChange={(value: any) => handleChangeIndustryLevel2(value)}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">経験した業種３</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              disabled={!formAdvanceData.industry_2_id}
              options={industry3Options}
              placeholder=""
              value={formAdvanceData.industry_3_id}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, industry_3_id: value }))
              }}
            />
          </div>
        </div>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-2">
            <label className="block text-sm mb-2 alu-text-base-1">希望条件</label>
            {/* change_job */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={expectedConditionOptions}
              placeholder=""
              value={formAdvanceData.expected_condition}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, expected_condition: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1"></div>
        </div>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">希望する勤務地</label>
            {/* change_job */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={preferredCityOptions}
              placeholder=""
              value={formAdvanceData.preferred_city_id}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, preferred_city_id: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">希望する雇用形態</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={workingStyleOptions}
              placeholder=""
              value={formAdvanceData.working_style_id}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, working_style_id: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1"></div>
        </div>
        <div className='grid grid-cols-3 gap-10'>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">転職意欲</label>
            {/* change_job */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={changeJobOptions}
              placeholder=""
              value={formAdvanceData.change_job}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, change_job: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1">
            <label className="block text-sm mb-2 alu-text-base-1">副業意欲</label>
            {/* work_parttime */}
            <Dropdown
              clearable={true}
              inputWidth="full"
              options={changeJobOptions}
              placeholder=""
              value={formAdvanceData.work_parttime}
              onChange={(value: any) => {
                setFormAdvanceData((prev) => ({ ...prev, work_parttime: value }))
              }}
              multiple={true}
            />
          </div>
          <div className="col-span-1"></div>
        </div>
      </div>
    </>
  )
}

export default CareerSection